
import { z } from "zod";

export const PandadocDocumentStatusValues = ["document.uploaded", "document.draft", "document.sent", "document.viewed", "document.completed", "document.voided", "document.declined"] as const;
export const PandadocDocumentStatusSchema = z.enum(PandadocDocumentStatusValues);
export const PandadocDocumentStatus = PandadocDocumentStatusSchema.enum;
export type PandadocDocumentStatus = (typeof PandadocDocumentStatusValues)[number];
